<template>
  <div class="my">
    <div class="profile_top bgwhite">
      <img v-lazy="userprofile.avatar_url" class="headimg">
      <div class="body">
        <div class="username">{{ userprofile.nickname }}</div>
        <div class="userid">ID：{{ userprofile.uuid }}</div>
      </div>
      <div class="detail" @click="gotoProfile">
        <div>个人信息</div>
        <van-icon class="goto" name="arrow"/>
      </div>
    </div>

    <div class="mt15" v-if="is_leader">
      <van-cell title="我建的班级" icon="todo-list-o" is-link to="/manage/clazz/list" />
    </div>

    <div class="mt15">
      <van-cell title="收货地址" icon="points" is-link to="/my/address" />
      <van-cell title="我的订单" icon="shopping-cart-o" is-link to="/my/order" />
      <van-cell title="我的班级" icon="flower-o" is-link to="/my/clazz" />
      <van-cell title="我的赛事" icon="diamond-o" is-link to="/my/race" />
      <van-cell title="我的打卡" icon="records" is-link to="/my/record" />
    </div>

    <!-- <div class="mt15 after_border"> -->
      <!-- <van-cell title="身体数据" icon="like-o" is-link /> -->
      <!-- <van-cell title="个人设置" icon="setting-o" is-link /> -->
      <!-- <van-cell title="玩法规则" icon="diamond-o" is-link /> -->
      <!-- <van-cell title="常见问题" icon="flag-o" is-link /> -->
    <!-- </div> -->

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Icon, Cell, CellGroup } from 'vant'

export default {
  name: 'My',
  components: {
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'userprofile',
      'is_leader'
    ])
  },
  created () {
  },
  methods: {
    gotoProfile () {
      this.$router.push('/profile')
    }
  }
}
</script>

<style scoped lang="scss">
.my {
  background-color: #f8f8f8;
}
.profile_top {
  width: 750px;
  height: 120px;
  padding: 30px 0;
  color: #323233;
  // border-bottom: 1px solid #ebedf0;
  display: flex;
  justify-content: space-between;
  .headimg {
    width: 120px;
    height: 120px;
    object-fit: cover;
    margin-left: 30px;
    border-radius: 50%;
  }
  // .body, .detail {
  //   display: flex;
  //   align-items: center;
  // }
  .body {
    width: 360px;
    font-size: 38px;
  }
  .userid {
    font-size: 26px;
    font-weight: bold;
    margin-top: 5px;
    padding-left: 5px;
  }
  .detail {
    font-size: 28px;
    margin-right: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    .goto {
      font-size: 32px;
      margin-left: 10px;
    }
  }
}
</style>
